export default "__VITE_ASSET__DgVyFGXQ__"